export const getKeyFromObjectWithDotNotation = <T = unknown>(
  obj: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
  },
  keyStr: string
): T => {
  const arr = keyStr.split('.');
  return arr.reduce((prev, current) => prev[current], obj) as T;
};
